export default function textWrap(txt) {
  if (!txt) return [];
  return txt.split(/[\r\n]+/).filter(Boolean);
}
